import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ConstantsService} from "../ConstantsService";
import {FormFormasEntregaComponent} from "../../superadmin/form-formasdeentrega/form-formasdeentrega.component";
import {EmpresasService} from "../../superadmin/services/empresas.service";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SelectEvent, TabStripComponent} from "@progress/kendo-angular-layout";
import {RotaGuardClient} from "../../guards/auth-loja.guard";
import {SECOES_FORMAS_ENTREGA} from '../../superadmin/form-formasdeentrega/secoes-formas-entrega';

@Component({
  selector: 'app-tela-config-empresa',
  templateUrl: './tela-config-empresa.component.html',
  styleUrls: ['./tela-config-empresa.component.scss']
})
export class TelaConfigEmpresaComponent implements OnInit, OnDestroy {
  @ViewChild('tabstrip', { static: false }) private tabstrip: TabStripComponent;
  @ViewChild('tabHorarios', { static: false }) private tabHorarios: TabStripComponent;
  @ViewChild('tabFidelidade', { static: false }) private tabFidelidade: TabStripComponent;
  private destruir$ = new Subject<void>();
  private selecaoPendente: ReturnType<typeof setTimeout>;
  @ViewChild('frmFormaEntrega') frmFormaEntrega: FormFormasEntregaComponent;
  @ViewChild('appFotos') appFotos: any;
  empresa: any;
  usuario: any;
  salvando: boolean;
  mensagemSucesso: any;
  erroNavegacao = '';
  agora: Date;
  fusos = [{ descricao: 'UTC -02:00 (Fernando Noronha Time - FNT)', valor: -2},
    { descricao: 'UTC -03:00 (Brasília Time - BRT)', valor: -3 },
    { descricao: 'UTC -04:00 (Amazonas Time - AMT)', valor: -4 },
    { descricao: 'UTC -05:00 (Acre Time - ACT)', valor: -5 }
  ];
  fusoHorario: any;
  nomeTabFormasPagamento = 'Formas de Pagamento';
  nomeTabHorario = 'Horários';
  nomeTabImpressao = 'Impressão';
  nomeTabUsuarios = 'Usuários';
  nomeTabKeeta = 'Integração com Keeta'
  nomeTabIfood = 'Integração com Ifood'
  nomeTab99Food = 'Integração com 99Food'
  nomeTabOpenDelivery = 'Integração OpenDelivery'
  possuiModuloFiscal: boolean;
  possuiModuloKDS: boolean;
  constructor(private constantsService: ConstantsService, private autorizacaoService: AutorizacaoService,
              private  activatedRoute: ActivatedRoute,
              private empresasService: EmpresasService, private router: Router) {
    this.agora = new Date();

  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser();

    this.constantsService.moduloFiscal$.pipe(takeUntil(this.destruir$)).subscribe(possui => { this.possuiModuloFiscal = possui });
    this.constantsService.possuiModuloKDS$.pipe(takeUntil(this.destruir$)).subscribe(possui => { this.possuiModuloKDS = possui ;
       this.nomeTabImpressao = possui ? 'Impressão / KDS' : 'Impressão';

    });

    this.constantsService.empresa$.pipe(takeUntil(this.destruir$)).subscribe( empresa => {
      if(empresa){
        this.empresa = empresa;
        this.setFusoEmpresa();
        this.agendeSelecaoDaRota(true);
      }
    });
    this.activatedRoute.paramMap.pipe(takeUntil(this.destruir$)).subscribe(() => this.agendeSelecaoDaRota());
  }

  ngOnDestroy() {
    clearTimeout(this.selecaoPendente);
    this.destruir$.next();
    this.destruir$.complete();
  }

  selecionouAba(event: SelectEvent): void {
    const rotas: {[titulo: string]: string} = {
      'Formas de entrega': '/admin/loja',
      [this.nomeTabHorario]: '/admin/loja/tab/horarios',
      'Cardápio': '/admin/loja/tab/cardapio', 'Caixa': '/admin/loja/tab/caixa',
      [this.nomeTabImpressao]: '/admin/loja/tab/impressao',
      [this.nomeTabFormasPagamento]: '/admin/loja/formaspagamento/offline',
      'Mesas': '/admin/mesas/configuracoes', 'Cupons': '/admin/cupons', 'Promoções': '/admin/promocoes',
      'Adicionais de Pedido': '/admin/loja/tab/adicionais-pedido',
      [this.nomeTabUsuarios]: '/admin/loja/tab/usuarios', 'Fidelidade': '/admin/loja/tab/fidelidade',
      'Integração com Pdv': '/admin/loja/integracao/pdv',
      'Integração com Delivery': '/admin/loja/integracao/delivery',
      [this.nomeTabIfood]: '/admin/loja/tab/ifood', [this.nomeTabKeeta]: '/admin/loja/tab/keeta',
      [this.nomeTab99Food]: '/admin/loja/tab/99food', 'Fotos': '/admin/loja/tab/fotos',
      'Banners': '/admin/loja/tab/banners',
      [this.nomeTabOpenDelivery]: '/admin/loja/tab/opendeliveryss'
    };
    this.navegueParaAba(event, rotas[event.title]);
  }

  selecionouAbaHorarios(event: SelectEvent): void {
    this.navegueParaAba(event, '/admin/loja/tab/' + (event.index === 1 ? 'pausasprogramadas' : 'horarios'));
  }

  selecionouAbaFidelidade(event: SelectEvent): void {
    const abas = ['fidelidade', 'fidelidade-planos', 'fidelidade-atividades', 'fidelidade-brindes'];
    if (abas[event.index]) this.navegueParaAba(event, '/admin/loja/tab/' + abas[event.index]);
  }

  private navegueParaAba(event: SelectEvent, rota: string): void {
    if (!rota || this.router.url.split('?')[0] === rota) return;
    // A rota seleciona a aba após o guard; uma navegação cancelada mantém a tela atual.
    event.preventDefault();
    this.erroNavegacao = '';
    this.router.navigateByUrl(rota).then(ok => {
      if (!ok) this.erroNavegacao = 'Não foi possível trocar de seção. A tela atual foi mantida.';
    }).catch(() => this.erroNavegacao = 'Não foi possível abrir esta seção. Tente novamente.');
  }

  private agendeSelecaoDaRota(atualizarEmpresa = false) {
    clearTimeout(this.selecaoPendente);
    this.selecaoPendente = setTimeout(() => {
          if (!this.empresa || !this.tabstrip) return;
          if(atualizarEmpresa && this.frmFormaEntrega) this.frmFormaEntrega.exibaFormasEmpresa();

          let nometab: any = this.activatedRoute.snapshot.params.nometab;
          let formapagamento = this.activatedRoute.snapshot.params.formapagamento;
          let parceiro = this.activatedRoute.snapshot.params.parceiro;

          if (SECOES_FORMAS_ENTREGA.some(secao => secao.id === nometab)) {
            this.exibaAba('Formas de entrega');
            this.selecaoPendente = setTimeout(() => this.frmFormaEntrega?.exibaSecao(nometab), 0);
            return;
          }

           if(nometab === 'pausasprogramadas')
             return this.exibaAbaPausasProgramadas();

           if(nometab === 'impressao')
             return this.exibaAbaImpressao();

          if(nometab === 'usuarios' && this.podeGerenciarUsuariosLoja())
            return this.exibaAba(this.nomeTabUsuarios)

          if(nometab === 'keeta')
            return   this.exibaAba(this.nomeTabKeeta)

          if(nometab === 'ifood')
            return this.exibaAba(this.nomeTabIfood)

          if(nometab === '99food')
            return this.exibaAba(this.nomeTab99Food)

          if(nometab === 'opendeliveryss')
            return this.exibaAba(this.nomeTabOpenDelivery)

          if (nometab === 'horarios') {
            this.exibaAba(this.nomeTabHorario);
            this.selecaoPendente = setTimeout(() => this.tabHorarios?.selectTab(0), 0);
            return;
          }
          const abas = {
            cardapio: 'Cardápio', caixa: 'Caixa',
            'adicionais-pedido': 'Adicionais de Pedido', fotos: 'Fotos', banners: 'Banners'
          };
          if (abas[nometab]) return this.exibaAba(abas[nometab]);
          if (['fidelidade', 'fidelidade-planos', 'fidelidade-atividades', 'fidelidade-brindes'].includes(nometab)) {
            this.exibaAba('Fidelidade');
            this.selecaoPendente = setTimeout(() => {
              this.tabFidelidade?.selectTab(['fidelidade', 'fidelidade-planos', 'fidelidade-atividades', 'fidelidade-brindes'].indexOf(nometab));
            }, 0);
            return;
          }

          if(formapagamento) this.exibaFormapagamentoOnline()

          if(parceiro) this.exibaAbaIntegracaoParceiro(parceiro)
          if (!nometab && !formapagamento && !parceiro) this.exibaAba('Formas de entrega');
    }, 0);
  }

  exibaFormapagamentoOnline(meiopagamento: string = 'pagarme'){
    //meiopagamento === 'pagarme'

    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tabFormasPagamento: any = tabs.find((_tab: any) => _tab.title ===  this.nomeTabFormasPagamento);

    if (tabFormasPagamento)
      this.tabstrip.selectTab(tabs.indexOf(tabFormasPagamento))
  }

  exibaAbaPausasProgramadas(){

    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tab: any = tabs.find((_tab: any) => _tab.title ===  this.nomeTabHorario);

    if (tab){
      this.tabstrip.selectTab(tabs.indexOf(tab))

      this.selecaoPendente = setTimeout(() => {
          //exibir  Pausa Programada
           this.tabHorarios?.selectTab(1)
      }, 100)
    }
  }

  exibaAba(nome: string){
    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tab: any = tabs.find((_tab: any) => _tab.title === nome  );

    if (tab)
      this.tabstrip.selectTab(tabs.indexOf(tab))
  }

  exibaAbaKeeta(){

  }

  exibaAbaImpressao(){
    this.exibaAba(this.nomeTabImpressao)
  }

  podeGerenciarUsuariosLoja() {
    return RotaGuardClient.gerenciarUsuariosLoja(this.usuario);
  }

  podeGerenciarLoja() {
    return RotaGuardClient.gerenciaLoja(this.usuario);
  }

  exibaAbaIntegracaoParceiro(parceiro: string){
    const tabs = this.tabstrip.tabs.toArray(); // Obtenha todas as abas como um array
    const tabFormasPagamento: any = tabs.find((_tab: any) => _tab.title.toUpperCase().indexOf(parceiro.toUpperCase()) >= 0);

    if (tabFormasPagamento)
      this.tabstrip.selectTab(tabs.indexOf(tabFormasPagamento))
  }

  moduloAtivo(nome: string) {
    if(!this.empresa) return false;

    return this.constantsService.possuiModulo(this.empresa, nome);
  }

  possuiModuloPagamentosEletronicos() {
    return !!this.empresa && (this.empresa.modulos || []).some(modulo => Number(modulo.id) === 20);
  }

  possuiCardapioOuPedidos() {
    return this.moduloAtivo('cardápio') || this.moduloAtivo('pedidos');
  }

  possuiPedidosOuMesas() {
    return this.moduloAtivo('pedidos') || this.moduloAtivo('mesas_garcom');
  }

  recursoAtivo(slug: string) {
    if(!this.empresa) return false;

    return this.constantsService.possuiRecurso(this.empresa, slug);
  }



  fecheMensagemSucesso() {
    delete this.mensagemSucesso;
  }


  private setFusoEmpresa() {
    this.fusoHorario = this.fusos.find( fuso => fuso.valor === this.empresa.fusoHorario);
  }


  selecionouFuso() {

    this.empresasService.atualizeFusoHorario(this.empresa, this.fusoHorario.valor).then( () => {
      this.empresa.fusoHorario = this.fusoHorario.valor;
    }).catch((err) => {
      this.setFusoEmpresa();
      alert(err)
    })
  }
}
